import Agent from '../service/agent'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getagents(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.getagents(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getagent(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.getagent(payload), {
        type: 'info',
        success,
        fail
      })
    },
    setagentinviter(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.setagentinviter(payload), {
        type: 'action',
        success,
        fail
      })
    },
    auditagent(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.auditagent(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deleteagent(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.deleteagent(payload), {
        type: 'action',
        success,
        fail
      })
    },
    unbindzsdealer(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.unbindzsdealer(payload), {
        type: 'action',
        success,
        fail
      })
    },
    bindzsdealer(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.bindzsdealer(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getagentcommissionrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.getagentcommissionrule(payload), {
        type: 'info',
        success,
        fail
      })
    },
    configagentcommissionrule(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.configagentcommissionrule(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getbindablezsdealers(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.getbindablezsdealers(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getcommissioncleanings(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.getcommissioncleanings(payload), {
        type: 'list',
        success,
        fail
      })
    },
    ackcommissioncleaning(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.ackcommissioncleaning(payload), {
        type: 'action',
        success,
        fail
      })
    },
    getagentcommissions(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.getagentcommissions(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getagentcommission(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.getagentcommission(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getagentorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.getagentorders(payload), {
        type: 'list',
        success,
        fail
      })
    },
    sumagentcommission(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Agent.sumagentcommission(payload), {
        type: 'info',
        success,
        fail
      })
    }
  }
}
